var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dropdown } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var ChangeAutomatedActionStatus = /** @class */ (function (_super) {
    __extends(ChangeAutomatedActionStatus, _super);
    function ChangeAutomatedActionStatus(props) {
        var _this = _super.call(this, props) || this;
        _this.onAutomatedActionChange = function (_, data) {
            _this.setState({
                automatedActions: data.value
            });
        };
        _this.submit = function () {
            var endpointPrefix = "";
            if (_this.props.userLevel) {
                endpointPrefix = "/admin/users/id";
            }
            else {
                endpointPrefix = "/admin/orders/id";
            }
            _this.props.postRequest(endpointPrefix + "/" + encodeURIComponent(_this.props.resourceId) + "/automated-actions", { automatedActions: _this.state.automatedActions });
        };
        _this.state = {
            automatedActions: props.currentAutomatedActionStatus
        };
        return _this;
    }
    ChangeAutomatedActionStatus.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/automatedActions', errors: this.props.state.errors, required: true, labelContent: 'Automated Action Status' },
                React.createElement(Dropdown, { placeholder: 'Configure Automated Actions', options: this.props.automatedActionOptions.map(function (o) {
                        return {
                            text: o,
                            value: o
                        };
                    }), multiple: true, onChange: this.onAutomatedActionChange, value: this.state.automatedActions })),
            React.createElement(Button, { disabled: this.props.state.loading
                    || this.props.state.success
                    || this.state.automatedActions === this.props.currentAutomatedActionStatus, icon: 'edit', label: 'Edit Automated Actions List', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return ChangeAutomatedActionStatus;
}(React.PureComponent));
export default ChangeAutomatedActionStatus;
//# sourceMappingURL=ChangeAutomatedActionStatus.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ChangeAutomatedActionStatus.js
// module id = 618
// module chunks = 0